import { Route } from "react-router-dom";

import LoginLayout from "layouts/LoginLayout";
import Login from "pages/login/Login";
import KakaoCallback from "pages/login/KakaoCallback";
import NaverCallback from "pages/login/NaverCallback";
import AppleCallback from "pages/login/AppleCallback";
import Register from "pages/account/Register";
import SignupTerms from "pages/account/SignupTerms";
import SocialSignup from "pages/account/SocialSignup";
import AccountRecovery from "pages/account/AccountRecovery";
import NotFound from "../pages/NotFound";
import Maintenance from "../pages/Maintenance";
import Start from "../pages/muyeon/Start";

// 무용연 공개 라우트 (인증 불필요)
const PublicRoutes = (
  <>
    <Route element={<LoginLayout />}></Route>

    <Route>
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/kakao" element={<KakaoCallback />} />
      <Route path="/naverAuth" element={<NaverCallback />} />
      <Route path="/appleAuth" element={<AppleCallback />} />
      <Route path="/signupTerms" element={<SignupTerms />} />
      <Route path="/register" element={<Register />} />
      <Route path="/social-signup" element={<SocialSignup />} />
      <Route path="/accountRecovery" element={<AccountRecovery />} />
      <Route path="/notFound" element={<NotFound />} />
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="/" element={<Start />} />
    </Route>
  </>
);

export default PublicRoutes;
